import { Component, OnInit } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoCustomerCommission } from 'app/shared/models/position/dto-customer-commission.model';
import { IResult } from 'app/shared/models/result.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { ModalCustomerCommissionComponent } from 'app/views/modales/position/customer-commission/modal-customer-commission.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { CustomerService } from '../customer.service';
import { PositionService } from '../position.service';

@Component({
  selector: 'app-customer-commissions',
  templateUrl: './customer-commissions.template.html',
  styleUrls: ['./customer-commissions.style.scss']
})
export class CustomerCommissionsComponent implements OnInit {
  private search: string;
  /**Modales */
  private modalRef: BsModalRef;
  private configModal = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };
  /**Validadores */
  private errorMessages: any;
  /**Variable de trasporte de datos */
  private result: IResult;
  /**Variables */
  private now: number;
  private customerId: number;
  /**Listas */
  private customerCommissions = new Array() as IDtoCustomerCommission[];
  private customerCommissionsTemp = new Array() as IDtoCustomerCommission[];
  /**Catalogos */
  private catalogCustomers: Observable<IDtoCatalog[]>;
  public constructor(private configurationService: ConfigurationService
    , private spinner: NgxSpinnerService
    , private modalService: BsModalService
    , private customerService: CustomerService
    , private positionService: PositionService
    , private configGeneral: AppConfig) {
  }

  ngOnInit(): void {
    this.now = Date.now();
    if (this.configurationService.isReady) {
      this.catalogCustomers = this.customerService.getCatalogCustomers();
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.catalogCustomers = this.customerService.getCatalogCustomers();
      });
    }
  }

  private getCustomerCommissions(dto: IDtoCatalog): void {
    if (dto == null) {
      return;
    }
    this.spinner.show()
    this.positionService.getCustomerCommissionsByCustumerId(dto.id)
      .subscribe(
        (x) => {
          this.customerCommissions = x.data as IDtoCustomerCommission[];
          this.customerCommissionsTemp = x.data as IDtoCustomerCommission[];
          this.spinner.hide();
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
  private openModalCustomerCommission(item: IDtoCustomerCommission, action: string) {
    if (this.customerId == null) {
      this.configGeneral.newToast('Validación', 'Debe seleccionar primero un cliente para poder dar de alta una comisión', 'warning');
      return;
    }
    if (action === 'add') {
      let commissions0 = this.customerCommissionsTemp.filter(c => c.classification == 0);
      let commissions1 = this.customerCommissionsTemp.filter(c => c.classification == 1);
      if (commissions0.length == 7) {
        this.configGeneral.newToast('Validación', 'No es posible agregar mas de 7 comisiones FIJAS por cliente', 'warning');
        return;
      }
      if (commissions1.length == 7) {
        this.configGeneral.newToast('Validación', 'No es posible agregar mas de 7 comisiones VARIABLES por cliente', 'warning');
        return;
      }
    }
    const initialState = {
      customerId: this.customerId,
      customerCommission: item,
      title: action == 'edit' ? `Edición de comisión ${item.name}` : `Nueva comisión`,
      action: action
    };
    this.modalRef = this.modalService.show(ModalCustomerCommissionComponent
      , Object.assign({ initialState }
        , this.configModal));
    this.modalRef.content.onClose.subscribe((result) => {
      if (result) {
        let dto = {} as IDtoCatalog;
        dto.id = this.customerId;
        this.getCustomerCommissions(dto);
      } else {
        this.configGeneral.newToast('Error', 'Ocurrió un error al intentar guardar los datos, intente de nuevo', 'error');
      }
    });
  }
  private updateFilter() {
    if (this.search === undefined) {
      return;
    }
    const val = this.search.toLowerCase();
    const temp = this.customerCommissionsTemp.filter((x: any) => x.name.toLowerCase().startsWith(val)
      || x.description.toLowerCase().startsWith(val));

    this.customerCommissions = temp;
  }
}
